import React from 'react'

const Soccer = ({ width = '24px', height = '25px', fill = '#fff' }) => {
  return (
    <svg style={{ width, height, fill }} viewBox='0 0 24 24' version='1.1'>
      <title>Soccer</title>
      <g id='Pre-Reg-Landing-Page' stroke='none' strokeWidth='1' fillRule='evenodd'>
        <g id='Desktop-10-Copy' transform='translate(-506.000000, -323.000000)' fillRule='nonzero'>
          <g id='onboarding/sport-copy-15' transform='translate(465.000000, 299.000000)'>
            <g id='icon/16/sport/soccer/soccer-ball' transform='translate(41.000000, 24.089286)'>
              <path
                d='M12,-1.70530257e-13 C15.1825979,-1.70530257e-13 18.2348448,1.26428208 20.4852814,3.51471863 C22.7357179,5.76515517 24,8.81740212 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,-1.70530257e-13 12,-1.70530257e-13 Z M15.675,2.58 L12,5.25 L8.325,2.58 C6.79697075,3.17266751 5.43735951,4.13057543 4.365,5.37 L4.365,5.37 L5.655,9.345 L1.875,12.09 C1.89867077,13.8640369 2.38466829,15.6012195 3.285,17.13 L3.285,17.13 L7.65,17.13 L9.15,21.705 C10.0744873,21.9829996 11.0346191,22.1244927 12,22.125 C12.9652711,22.1230077 13.9251895,21.981546 14.85,21.705 L14.85,21.705 L16.35,17.13 L20.715,17.13 C21.6198782,15.6031589 22.106222,13.8647382 22.125,12.09 L22.125,12.09 L18.345,9.345 L19.635,5.385 C18.5635334,4.14101542 17.20402,3.17802676 15.675,2.58 L15.675,2.58 Z M11.895,7.455 L16.05,10.47 L14.475,15.345 L9.33,15.345 L7.755,10.47 L11.895,7.455 Z'
                id='path'
                transform='translate(12.000000, 12.000000) rotate(-30.000000) translate(-12.000000, -12.000000) '
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Soccer
